import React from 'react';
import { Row, Col, Card, Form, Input, Button, Checkbox } from 'antd';
import { FormInstance } from 'antd/lib/form';
const { TextArea } = Input;

const layout = {
  labelCol: { span: 3 },
  wrapperCol: { span: 21 },
  labelAlign: 'left'
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

class NoteModel extends React.Component {
  constructor (props) {
    super(props)

    this.formRef = React.createRef()

    this.state = {
    }
  }

  onFinish = values => {
    console.log('Success:', values);
  };

  onFinishFailed = errorInfo => {
    console.log('Failed:', errorInfo);
  };

  async vaild () {
    const values = await this.formRef.current.validateFields().catch(console.log)
    console.log('values', values)
    return values
  }

  clear () {
    this.formRef.current.resetFields();
  }

  edit = (item) => {
    this.formRef.current.setFieldsValue(item);
  }

  async componentDidMount () {
    // console.log('this.formRef.current', this.formRef.current)
  }

  render () {
    const { state } = this
    return (
      <div>
        <Form
          ref={this.formRef}
          {...layout}
          name="basic"
          initialValues={{ remember: true }}
          onFinish={this.onFinish}
          onFinishFailed={this.onFinishFailed}
        >
          <Form.Item
            hidden={true}
            label="Id"
            name="id"
            rules={[{ required: false }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: 'Please input your title!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Intro"
            name="intro"
            rules={[{ required: true, message: 'Please input your intro!' }]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            label="Content"
            name="content"
            rules={[{ required: true, message: 'Please input your content!' }]}
          >
            <TextArea rows={10} />
          </Form.Item>
{/* 
          <Form.Item {...tailLayout} name="remember" valuePropName="checked">
            <Checkbox>Remember me</Checkbox>
          </Form.Item>

          <Form.Item {...tailLayout}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item> */}
        </Form>
      </div>
    )
  }
}

export default NoteModel;
